import { useUpdateAtom } from "jotai/utils";
import { devMenuOpenAtom } from "../store/game";



export function useDevMenuControls() {

  const setDevMenu = useUpdateAtom(devMenuOpenAtom)


  return {
    onClose: () => setDevMenu(false),
    onOpen: () => setDevMenu(true)
  }

}